import { useLocalStorage } from 'usehooks-ts';
import { useEffect } from 'react';
import useListenFromRn from '../utilities/useListenFromRn';
import { createOrUpdateLiveNotification } from '@/lib/db/DBNotificationHelpers';
import useGetLocation from '../utilities/useGetLocation';
import { useMixpanel } from '@/lib/misc/mixpanel';
export default function useSetExpoToken(PKP) {
    var useRNHandler = useListenFromRn().useRNHandler;
    var _a = useLocalStorage('expoPushToken', ''), expoPushToken = _a[0], setExpoPushToken = _a[1];
    var _b = useLocalStorage('blockApp', false), blockApp = _b[0], setBlockApp = _b[1];
    var _c = useMixpanel(), LogToMixpanel = _c.LogToMixpanel, EVENTS = _c.EVENTS, CATEGORIES = _c.CATEGORIES;
    var _d = useLocalStorage('deviceData', {}), deviceData = _d[0], setDeviceData = _d[1];
    var locationData = useGetLocation().data;
    useRNHandler('EXPO_PUSH_TOKEN', function (payload) {
        console.log('EXPO_PUSH_TOKEN', payload);
        try {
            payload = JSON.parse(payload);
        }
        catch (_) {
            //
        }
        if (payload) {
            setExpoPushToken(payload.expo_token);
            setDeviceData(payload.device_data);
        }
    });
    useRNHandler('BLOCK_APP', function (payload) {
        console.log('BLOCK_APP', payload);
        try {
            payload = JSON.parse(payload);
        }
        catch (_) {
            //
        }
        if (payload.block) {
            setBlockApp(true);
        }
        else {
            setBlockApp(false);
        }
    });
    useEffect(function () {
        if (expoPushToken) {
            LogToMixpanel({
                pkp: PKP,
                eventName: EVENTS.auth.notif_token,
                category: CATEGORIES.auth,
                metaData: {
                    expo_token: expoPushToken
                },
            });
            createOrUpdateLiveNotification({
                expo_token: expoPushToken,
                location_data: locationData,
                device_data: deviceData,
                pkp_eth_address: PKP === null || PKP === void 0 ? void 0 : PKP.ethAddress,
            });
        }
    }, [expoPushToken, PKP]);
}
